module.exports = __webpack_public_path__ + "media/images/navbar-faq-icon-ccf07973e81e56e81f805de240d691dd.svg";